import React from 'react';
import API from '../../../api';

export default class CardProfile extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      count: 1
    }
    this.sum = this.sum.bind();
    this.res = this.res.bind();
    this.handleClick = this.handleClick.bind();
  }

  componentDidMount(){
    this.setState({list: this.props})
  }

  sum = () => {
    this.setState({count: this.state.count+1}, () => {
      this.props.quantity(this, this.state.count);  
    })
  }

  res = () => {
    // Set min limit = 0
    if( this.state.count > 1 ){
      this.setState({count: this.state.count-1}, () => {
        this.props.quantity(this, this.state.count);  
      })
    }
  }

  handleClick = (e) => {
  }

  render() {
    return (
      <div className='card' data-count={this.state.count}>
        <div className='inner'>
          <h3>{this.props.content.name}</h3>
          <p>${this.props.min_range} - ${this.props.max_range}</p>
          <ul>
            {
              this.props.content.description.map( (item,index) => {
                return <li key={`${this.props.content.name}-${index}`}>{item}</li>
              })
            }
          </ul>
          <div className='control-count'>Quantity: <span>{this.state.count}</span>
            <button onClick={this.sum}>+</button>
            <button onClick={this.res}>-</button>
          </div>
        </div>
      </div>            
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/build-your-team/views/card.js